(w => {

    w.PubSub.subscribe('externaltracking.shopcart.addtocart', function (_, data) {
        if (!data || !data.items || !data.items.length) { return; }
        const prodIds = data.items.map(item => item.product.productNo ? item.product.productNo : ('' + item.product.productId));
        const value = data.items.reduce((sum, item) => sum + item.quantity * item.unitPrice, 0);
        w.fbq('track', 'AddToCart', {
            content_ids: prodIds,
            content_type: 'product',
            value: value,
            currency: data.currencyCode
        });
    });

})(window);